"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPopupContainer = exports.PopupContainerProvider = void 0;
var PopupContainerProvider_1 = require("./PopupContainerProvider");
Object.defineProperty(exports, "PopupContainerProvider", { enumerable: true, get: function () { return __importDefault(PopupContainerProvider_1).default; } });
Object.defineProperty(exports, "useGetPopupContainer", { enumerable: true, get: function () { return PopupContainerProvider_1.useGetPopupContainer; } });
//# sourceMappingURL=index.js.map